import { put, call, takeLatest, take, takeEvery } from "redux-saga/effects";
 
import { ADD_LIBRARY_SUCCESS,ADD_DISPLAY_FAILED,UPLOAD_SUCCESS,UPLOAD_FAILED,ADD_DISPLAY_SUCCESS,ADD_LIBRARY_FAILED, UPLOAD_IMAGE, DELETE_IMAGE, GET_LIBRARY_REQUEST, GET_DISPLAY_REQUEST, DELETE_DISPLAY, ADD_DISPLAY_REQUEST, TEMPLATE_REQUEST } from "./DisplayConstant";
import { addLibSuccess,addLibFailure,adddisplaySuccess,adddisplayFailure,uploadSuccess,uploadFailure, deleteSuccess, deleteFailure, getLibSuccess, getLibFailure, getDisplaySuccess, getDisplaybFailure, getDisplayFailure, deleteDisplaySuccess, deleteDisplayFailure, templateDataSuccess, templateDataFailure, uploadIndex } from "./DisplayAction";
import { createDisplayApi, deletedisplayApi, deleteImageApi, deletemageApi, DisplaygetApi, imageLibrarygetApi, templateApi, uploadImageApi } from "./DisplayApi";
 
 
function* uploadImage(action) {
  // const { dropDownType } = action.payload;
  try {
   
    const response = yield call(uploadImageApi, action.payload.formdata);
   
   
    if (response.status === 200) {
     
      yield put(uploadSuccess("success"));
      yield put(uploadIndex(action.payload.index));
 
    } else {
      yield put(uploadFailure({ message: "Please try again" }));
     
    }
  } catch (err) {
    yield put(uploadFailure({ message: "Please try again" }));
  }
}
 
 
function* deleteImage(action) {
  // const { dropDownType } = action.payload;
  try {
    const response = yield call(deleteImageApi, action.payload);
   
   
    if (response.status === 200) {
     
      yield put(deleteSuccess("success"));
    } else {
      yield put(deleteFailure({ message: "Please try again" }));
     
    }
  } catch (err) {
    yield put(deleteFailure({ message: "Please try again" }));
  }
}
 
 
function* deleteDisplay(action) {
  // const { dropDownType } = action.payload;
  try {
    const response = yield call(deletedisplayApi, action.payload.displayId);
   
   
    if (response.status === 200) {
 
     
     
      yield put(deleteDisplaySuccess("success"));
       yield put({
              type:GET_DISPLAY_REQUEST,
              payload: action.payload.locationId,
            });
    } else {
      yield put(deleteDisplayFailure({ message: "Please try again" }));
     
    }
  } catch (err) {
    yield put(deleteDisplayFailure({ message: "Please try again" }));
  }
}
 
function* LibraryList(action) {
  // const { dropDownType } = action.payload;
  try {
    const response = yield call(imageLibrarygetApi, action.payload);
   
   
    if (response.status === 200) {
     
      yield put(getLibSuccess(response.data));
    } else {
      yield put(getLibFailure({ message: "Please try again" }));
     
    }
  } catch (err) {
    yield put(getLibFailure({ message: "Please try again" }));
  }
}
function* DisplayList(action) {
  // const { dropDownType } = action.payload;
  try {
    const response = yield call(DisplaygetApi, action.payload);
   
   
    if (response.status === 200) {
     
      yield put(getDisplaySuccess(response.data));
    } else {
      yield put(getDisplayFailure({ message: "Please try again" }));
     
    }
  } catch (err) {
    yield put(getDisplayFailure({ message: "Please try again" }));
  }
}
 
function* createDisplay(action) {
 
  try {
    const response = yield call(createDisplayApi, action.payload);
   
   
    if (response.status === 200) {
     
      yield put(adddisplaySuccess(response.data));
    } else {
      yield put(adddisplayFailure({ message: "Please try again" }));
     
    }
  } catch (err) {
    yield put(adddisplayFailure({ message: "Please try again" }));
  }
}
function* templateDataSaga(action) {
 
  try {
    const response = yield call(templateApi, action.payload);
   
   
    if (response.status === 200) {
     
      yield put(templateDataSuccess(response.data));
    } else {
      yield put(templateDataFailure({ message: "Please try again" }));
     
    }
  } catch (err) {
    yield put(templateDataFailure({ message: "Please try again" }));
  }
}
export default function* spotlightDisplay() {
 
  yield takeLatest(UPLOAD_IMAGE,uploadImage );
  yield takeLatest(DELETE_IMAGE, deleteImage);
  yield takeLatest(GET_LIBRARY_REQUEST, LibraryList);
  yield takeLatest(GET_DISPLAY_REQUEST, DisplayList);
  yield takeLatest(DELETE_DISPLAY, deleteDisplay);
  yield takeLatest(ADD_DISPLAY_REQUEST, createDisplay);
  yield takeLatest(TEMPLATE_REQUEST, templateDataSaga);

}